<template>
  <div class="nav-container">
    <div class="nav-wrap">
      <div class="logo-wrap">
        <img src="@/assets/naic/logo.png" @click="handleNav2Home" />
      </div>
      <div class="broadcast-wrap">
        <i class="icon-broadcast"></i
        ><span
          >{{ curDate }} ｜ 最新报名：{{ totalTeams }} 支队伍 /
          {{ totalUsers }} 名选手</span
        >
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  // import bus from "../utils/EventBus";

  export default {
    name: "nav",
    props: ["isFixed"],
    data() {
      return {
        totalUsers: 7592,
        totalTeams: 7292,
      };
    },
    computed: {
      curDate() {
        return moment().format("YYYY/MM/DD");
      },
    },
    methods: {
      handleNav2Home(){
        this.$router.push('/')
      }
    },  
    mounted() {
      // bus.on("total", (data) => {
      //   this.totalTeams = data.team;
      //   this.totalUsers = data.user;
      // });
    },
  };
</script>

<style scoped lang="scss">
  .nav-container {
    width: 100%;
    height: 80px;
    .nav-wrap {
      max-width: 1200px;
      line-height: 80px;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      .logo-wrap {
        padding-top: 12px;
        cursor: pointer;
        height: 68px;
        img {
          width: 167px;
          height: 56px;
        }
      }
      .broadcast-wrap {
        .icon-broadcast {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url("../assets/naic/icon-1.png") no-repeat center center;
          background-size: 16px;
          transform: translateX(-8px) translateY(2px);
        }
        span {
          width: 396px;
          height: 22px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #3571b7;
          line-height: 19px;
        }
      }
    }
  }
</style>
